if (typeof Date.prototype.createFrenchDate !== 'function') {
    // eslint-disable-next-line no-extend-native
    Date.prototype.createFrenchDate = function(dateString) {
        let dateList = dateString.split("-");
        let date = new Date();
        date.setFullYear(dateList[2]);
        date.setMonth(dateList[1] - 1);
        date.setDate(dateList[0]);
        return date;
    }
}

export const getFormattedDate = (date) => {
    const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2);
    const formattedDay = ('0' + date.getDate()).slice(-2);
    return formattedDay + '-' + formattedMonth + '-' + date.getFullYear();
};

export const getFormattedTime = (date) => {
    const formattedHour = ('0' + date.getHours()).slice(-2);
    const formattedMinute = ('0' + date.getMinutes()).slice(-2);
    return formattedHour + ':' + formattedMinute;
};

export const getCorrectDefaultDateFormat = (defaultDate) => {
    if(!defaultDate) {
        return null;
    }
    // Format reçu : jj-mm-aaaa
    let defaultDateList = defaultDate.split('-');
    if(defaultDateList.length > 2 ) {
        // Année Mois Jours
        return new Date(defaultDateList[2], defaultDateList[1] - 1, defaultDateList[0]);
    } else {
        // Format pas bon
        return new Date();
    }
}


// WEBPACK FOOTER //
// ./src/utils/DateUtils.js